import { Fragment, useState } from "react";
import {
    Button,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
    Avatar,
    Chip,
} from "@material-tailwind/react";
import AIcon from "../partials/AIcon";
import parse from 'html-react-parser'
export default function ViewDialog({ v }) {


    //Close Dialog
    const closeDialog = () => {
        v.setShowViewDialog(false)
       // v.setModel(null)
    }

    

    const row = ({l,v}) => {
        console.log(l,v)
        return (
            <div className="grid  md:grid-cols-3 md:gap-3 my-3 md:my-2">
                <div className=" md:text-right text-blue-gray-300">{l} </div>
                <div className="col-span-2 text-blue-gray-900 flex border-b"> <span className="hidden md:block md:mr-1">:</span>
                    <div>
                    {l==='Status'?<Chip className='capitalize text-center' variant="ghost" size="sm" color={v === 1 ? 'green' : 'red'} value={v  === 1 ? 'Enable' : 'Disable'} />:''}
                        {typeof (v) == 'string' ? parse(v) : ''}

                        {l === "Companies" &&v && v?.map((d, i) => {
                            return <div key={i}>{d?.name_en} -- {d?.name_af}</div>
                        })}

                       
                    </div>   
                </div>
            </div>
        )

    }
    const logo = (o) => (
        <div className="grid grid-cols-3 gap-4 my-2">
            <div className="text-right text-blue-gray-300">{o.l} </div>
            <div className="col-span-2">
                <Avatar size="xxl" variant="rounded" withBorder={true} color="teal"
                    src={o.v}
                    alt="Image"
                    className=" p-0.5" />
            </div>

        </div>)

    return (
        <Fragment>

            <Dialog open={v.showViewDialog} className={`min-w-[90%] md:min-w-[40%] border-main-color absolute top-0  overflow-y-scroll ${v?.className} md:h-fit`}>
                <DialogHeader className="bg-main-color py-1 px-2 text-blue-gray-100  text-base flex justify-between">
                    {v.title}
                    <Button className="p-0 m-0 bg-transparent" onClick={closeDialog}>  <AIcon name="close-outline" size={20} className="p-1" /> </Button>
                </DialogHeader>
                <DialogBody divider>
                    {v.obj?.map((o, i) => (<div key={i}>  {o.l === "لوگو" || o.l === "Photo" ? logo(o) : row(o)}</div>))}
                    <div className="flex flex-row justify-between" >
                        <Button variant="outlined" color="red" onClick={closeDialog} className="py-0 px-1"> <AIcon name="close" size={20} /> </Button>
                    </div>
                </DialogBody>

            </Dialog>
        </Fragment>
    );
}